import PropTypes from 'prop-types';
import _ from "lodash";

const MoneyAmount = ({ config, amount, currencyConfig, round }) => {
  if (amount === undefined) return '-';

  const roundAmount = (value, rounding) => {
    if (rounding >= 0) return value.toFixed(rounding);
    const unit = Math.pow(10, -rounding);
    return (Math.floor(value / unit) * unit).toFixed(0);
  }

  const formatMoneyAmount = (amount, config, currencyConfig, returnOnlyAmount = false) => {
    if (_.isNil(amount)) return null;

    let roundedAmount = roundAmount(amount, round);

    if (returnOnlyAmount) return roundedAmount;

    roundedAmount = roundedAmount.toLocaleString();

    const currencyName = currencyConfig?.name || "";

    if (config.useCurrencySymbol)
      return `${currencyName ? config.currencySymbol[currencyName] : ""} ${roundedAmount}`;

    return `${roundedAmount} ${currencyName}`;
  };


  return (
    formatMoneyAmount(amount, config, currencyConfig)
  );
};

MoneyAmount.propTypes = {
  config: PropTypes.object,
  amount: PropTypes.number,
  currencyConfig: PropTypes.object,
};

export default MoneyAmount;
